export const isRuleSetValid = (segment) => {
  if (!segment.ruleSet) {
    return false
  }

  const ruleset = segment.ruleSet;
  const validGroups = ruleset.groups && ruleset.groups.length > 0
  const validFilters = validGroups
    && ruleset.groups.every(group => group.filters.every(isFilterValid))
  return !!validFilters;
}

const isFilterValid = (filter) => {
  const propertyIsValid = !!filter.property && !!filter.property.name && !!filter.property.entityType
  const operatorIsValid = !!filter.operator
  const valueIsValid = !!filter.value && !!filter.value.type && !!filter.value.value
  return propertyIsValid && operatorIsValid && valueIsValid
}